import IMask from 'imask'

export const maskCurrency = (
  padFractionalZeros = false,
  normalizeZeros = true,
  signed = false,
) => ({
  mask: Number, // enable number mask

  // other options are optional with defaults below
  scale: 2, // digits after point, 0 for integers
  signed, // disallow negative
  thousandsSeparator: ',', // any single char
  padFractionalZeros, // if true, then pads zeros at end to the length of scale
  normalizeZeros, // appends or removes zeros at ends
  radix: '.', // fractional delimiter
  mapToRadix: ['.'], // symbols to process as radix

  // additional number interval options (e.g.)
  // min: -10000,
  // max: 10000
})

export const maskNum = (
  padFractionalZeros = false,
  normalizeZeros = true,
  signed = false,
) => ({
  mask: Number, // enable number mask
  // other options are optional with defaults below
  scale: 2, // digits after point, 0 for integers
  signed, // disallow negative
  thousandsSeparator: ',', // any single char
  padFractionalZeros, // if true, then pads zeros at end to the length of scale
  normalizeZeros, // appends or removes zeros at ends
  radix: '.', // fractional delimiter
  mapToRadix: ['.'], // symbols to process as radix
})

export const usd = (value, padFractionalZeros, normalizeZeros) => {
  if (value == null) return '$0'
  // mask adapter
  const mask = IMask.createMask(
    maskCurrency(padFractionalZeros, normalizeZeros),
  )
  const str = mask.resolve(String(value / 100))
  // we remove [.00] in last
  const postfix = str.slice(-3)
  if (postfix === '.00') return '$' + str.slice(0, -3)
  else return '$' + str
}

export const usdNegative = (value, padFractionalZeros, normalizeZeros) => {
  if (value == null) return '$0'
  // mask adapter
  const mask = IMask.createMask(
    maskCurrency(padFractionalZeros, normalizeZeros, true),
  )
  const str = mask.resolve(String(value / 100))
  // we remove [.00] in last
  const postfix = str.slice(-3)
  if (postfix === '.00') return '$' + str.slice(0, -3)
  else return '$' + str
}

export const num = (value, padFractionalZeros, normalizeZeros) => {
  if (value == null) return '0'
  const mask = IMask.createMask(
    maskCurrency(padFractionalZeros, normalizeZeros, true),
  )
  const str = mask.resolve(String(value))
  // we remove [.00] in last
  const postfix = str.slice(-3)
  if (postfix === '.00') return str.slice(0, -3)
  else return str
}